// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3a55H","large":"styles_large__2MA99"};